(() => {
  const getSection = (root, fragment) => {
    if (root?.matches?.(`[id*="${fragment}"]`)) return root;
    return root?.querySelector?.(`[id*="${fragment}"]`) || document.querySelector(`[id*="${fragment}"]`);
  };

  const setButtonLabel = (section, label) => {
    const link = section?.querySelector('a.button');
    if (!link) return;
    const labelNode = link.querySelector('.label');
    if (labelNode) labelNode.textContent = label;
    else link.textContent = label;
    link.setAttribute('aria-label', label.replace(/\b\w/g, (char) => char.toUpperCase()));
  };

  const fixProductCardControls = () => {
    if (document.getElementById('ace-product-card-control-fixes')) return;
    const style = document.createElement('style');
    style.id = 'ace-product-card-control-fixes';
    style.textContent = `
      .product-grid .card-information__button {
        left: 50% !important;
        right: auto !important;
        transform: translate(-50%, calc(-100% - 3.2rem)) !important;
      }
      @media screen and (min-width: 750px) {
        .product-grid .card-information__button {
          transform: translate(-50%, calc(-100% - 4.2rem)) !important;
        }
      }
      .product-grid .card-information .button--soldout {
        left: 50% !important;
        right: auto !important;
        transform: translate(-50%, calc(-100% - 4.2rem)) !important;
      }
      @media screen and (max-width: 480px) {
        .product-grid:not(.grid--1-col-mobile) .card-information .button--soldout {
          transform: translate(-50%, calc(-100% - 1.2rem)) !important;
        }
      }
      .template-index [id*="featured_collection_Q8Ye7y"] .view-all .button {
        font-size: 1.4rem !important;
      }
      .template-index [id*="featured_collection_Q8Ye7y"] .view-all .button::after {
        content: none !important;
      }
      .template-index [id*="featured_collection_Q8Ye7y"] .title-wrapper--mobile-link .link .label {
        font-size: 1.25rem !important;
      }
      .template-index [id*="featured_collection_Q8Ye7y"] .title-wrapper--mobile-link .link .label::after {
        content: none !important;
      }
    `;
    document.head.appendChild(style);
  };

  const updateHomeWorkoutCta = (root = document) => {
    if (!document.body.classList.contains('template-index')) return;
    const section = getSection(root, 'featured_collection_Q8Ye7y');
    if (!section) return;
    section.querySelectorAll('a').forEach((link) => {
      if (!link.closest('.view-all') && !link.closest('.title-wrapper--mobile-link')) return;
      const label = link.querySelector('.label');
      if (label) label.textContent = 'EXPLORE HOME GYM & TRAINING';
      else link.textContent = 'EXPLORE HOME GYM & TRAINING';
      link.setAttribute('aria-label', 'Explore Home Gym & Training');
    });
    const heading = section.querySelector('.title');
    if (heading) {
      heading.textContent = 'HOME GYM & TRAINING';
      heading.closest('.title-wrapper')?.classList.remove('title-wrapper--no-heading');
    }
  };

  const updateTopPicksHeading = (root = document) => {
    if (!document.body.classList.contains('template-index')) return;
    const section = getSection(root, 'featured_collection_Gy7YcV');
    const heading = section?.querySelector('.title');
    if (heading) heading.textContent = 'ACEFINDZ TOP PICKS';
  };

  const updateHomepageProductCtas = (root = document) => {
    if (!document.body.classList.contains('template-index')) return;
    setButtonLabel(getSection(root, 'image_with_text_87cBDa'), 'SHOP TRAINING VEST');
    setButtonLabel(getSection(root, 'images_with_text_brFtnQ'), 'SHOP PULL-UP BANDS');
    setButtonLabel(getSection(root, 'image_banner_KgUBHm'), 'SHOP SMART HULA HOOP');
    setButtonLabel(getSection(root, 'images_with_text_DCWDbe'), 'SHOP GRIP PROTECTORS');
  };

  const enhanceSocialLinks = (root = document) => {
    const platforms = [['facebook.com', 'Facebook'], ['instagram.com', 'Instagram'], ['tiktok.com', 'TikTok']];
    root.querySelectorAll?.('.list-social__link[href]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      const match = platforms.find(([host]) => href.includes(host));
      if (!match) return;
      const platform = match[1];
      link.setAttribute('aria-label', `Follow AceFindz Fitness on ${platform}`);
      link.setAttribute('title', `AceFindz Fitness on ${platform}`);
      link.setAttribute('rel', 'noopener noreferrer');
    });
  };

  const enhanceAccessibility = (root = document) => {
    root.querySelectorAll?.('footer summary[tabindex="-1"]').forEach((summary) => summary.removeAttribute('tabindex'));
    root.querySelectorAll?.('.contact__list .list-social[role="lsit"]').forEach((list) => list.setAttribute('role', 'list'));
    root.querySelectorAll?.('#shopify-section-header .menu-drawer__menu-item').forEach((item) => {
      item.classList.remove('list-menu__itemfocus-inset');
      item.classList.add('list-menu__item', 'focus-inset');
    });
  };

  const polishCollectionAndTrending = () => {
    if (!document.getElementById('ace-visual-polish-20260915')) {
      const style = document.createElement('style');
      style.id = 'ace-visual-polish-20260915';
      style.textContent = `
        body.template-collection #MainContent,
        body.template-collection .collection-grid-section,
        body.template-collection #ProductGridContainer,
        body.template-collection #ProductGridContainer .collection,
        body.template-collection #ProductGridContainer .product-grid {
          background: #d8d8d8 !important;
        }
        body.template-collection .facets-container,
        body.template-collection .facets__form,
        body.template-collection facet-filters-form,
        body.template-collection .facets__wrapper {
          background: #ffffff !important;
        }
        body.template-collection #product-grid .grid__item > .card-wrapper,
        body.template-collection .product-grid .card-wrapper,
        body.template-collection .product-grid .card-information,
        body.template-collection .product-grid .card__content {
          background: #ffffff !important;
        }
        body.template-collection .collection-hero__description,
        body.template-collection .collection-hero__description p,
        body.template-collection .collection__description,
        body.template-collection .collection__description p,
        body.template-collection .rte,
        body.template-collection .rte p,
        body.template-collection .facets__heading,
        body.template-collection .facets__summary,
        body.template-collection .facets__label,
        body.template-collection .facet-filters__label,
        body.template-collection .product-count__text {
          color: #222222 !important;
          opacity: 1 !important;
        }
        body.template-index [id*="featured_collection_Q8Ye7y"] .title,
        body.template-index [id*="featured_collection_Q8Ye7y"] .title-wrapper-with-link,
        body.template-index [id*="featured_collection_Q8Ye7y"] .collection__description,
        body.template-index [id*="featured_collection_Q8Ye7y"] .collection__description p,
        body.template-index [id*="featured_collection_Q8Ye7y"] .rte,
        body.template-index [id*="featured_collection_Q8Ye7y"] .rte p {
          color: #222222 !important;
          opacity: 1 !important;
        }
        body.template-index [id*="featured_collection_Q8Ye7y"] .title {
          color: #e5070e !important;
        }

        body.template-index #MainContent .ace-trending-now {
          background: radial-gradient(circle at 50% -18%, #292929 0%, #151515 44%, #080808 100%) !important;
          border-top: 3px solid #e5070e !important;
          border-bottom: 1px solid rgba(229, 7, 14, .72) !important;
          padding-top: 5rem !important;
          padding-bottom: 5.4rem !important;
        }
        body.template-index #MainContent .ace-trending-now__head {
          max-width: 92rem !important;
          margin: 0 auto 3.2rem !important;
          padding: 0 2rem !important;
          background: transparent !important;
          box-shadow: none !important;
        }
        body.template-index #MainContent .ace-trending-now__eyebrow {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 0 0 1.4rem !important;
          padding: .62rem 1.15rem !important;
          color: #ff2a31 !important;
          background: rgba(229, 7, 14, .08) !important;
          border: 1px solid rgba(229, 7, 14, .65) !important;
          border-radius: 999px !important;
          font-family: var(--font-heading-family), Montserrat, Arial, sans-serif !important;
          font-size: 1.15rem !important;
          font-weight: 900 !important;
          letter-spacing: .22em !important;
          line-height: 1 !important;
          text-transform: uppercase !important;
        }
        body.template-index #MainContent .ace-trending-now__title {
          display: block !important;
          width: auto !important;
          max-width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
          color: #ffffff !important;
          background: none !important;
          border: 0 !important;
          box-shadow: none !important;
          opacity: 1 !important;
          font-family: var(--font-heading-family), Montserrat, Arial, sans-serif !important;
          font-size: clamp(3.2rem, 3.8vw, 5.2rem) !important;
          font-weight: 900 !important;
          line-height: .98 !important;
          letter-spacing: .025em !important;
          text-transform: uppercase !important;
          text-shadow: none !important;
          -webkit-text-fill-color: currentColor !important;
        }
        body.template-index #MainContent .ace-trending-now__title::before,
        body.template-index #MainContent .ace-trending-now__title::after {
          content: none !important;
          display: none !important;
        }
        body.template-index #MainContent .ace-trending-now__title .ace-viral-word {
          color: #e5070e !important;
          -webkit-text-fill-color: #e5070e !important;
        }
        body.template-index #MainContent .ace-trending-now__title::selection,
        body.template-index #MainContent .ace-trending-now__title *::selection {
          background: #e5070e !important;
          color: #ffffff !important;
        }
        body.template-index #MainContent .ace-trending-now__sub {
          max-width: 68rem !important;
          margin: 1.45rem auto 0 !important;
          color: rgba(255, 255, 255, .78) !important;
          font-family: var(--font-body-family), Arial, sans-serif !important;
          font-size: 1.55rem !important;
          font-weight: 500 !important;
          line-height: 1.55 !important;
          letter-spacing: .01em !important;
        }
        body.template-index #MainContent .ace-trending-now__sub::before,
        body.template-index #MainContent .ace-trending-now__sub::after {
          content: none !important;
          display: none !important;
        }
        body.template-index #MainContent .ace-trending-now__grid {
          gap: 1.6rem !important;
        }
        body.template-index #MainContent .ace-trending-card {
          border: 1.5px solid rgba(229, 7, 14, .82) !important;
          border-radius: 1.5rem !important;
          box-shadow: 0 12px 28px rgba(0, 0, 0, .28) !important;
        }
        body.template-index #MainContent .ace-trending-card__badge {
          padding: .6rem .95rem !important;
          background: #e5070e !important;
          font-size: 1rem !important;
          letter-spacing: .14em !important;
        }
        @media screen and (max-width: 749px) {
          body.template-index #MainContent .ace-trending-now {
            padding-top: 3.8rem !important;
            padding-bottom: 4rem !important;
          }
          body.template-index #MainContent .ace-trending-now__head {
            margin-bottom: 2.4rem !important;
            padding: 0 .8rem !important;
          }
          body.template-index #MainContent .ace-trending-now__title {
            font-size: clamp(2.7rem, 9vw, 3.8rem) !important;
          }
          body.template-index #MainContent .ace-trending-now__sub {
            font-size: 1.35rem !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    if (document.body.classList.contains('template-index')) {
      const eyebrow = document.querySelector('.ace-trending-now__eyebrow');
      const title = document.querySelector('.ace-trending-now__title');
      const sub = document.querySelector('.ace-trending-now__sub');
      if (eyebrow) eyebrow.textContent = 'ACEFINDZ TRENDING';
      if (title) title.innerHTML = '<span class="ace-viral-word">VIRAL</span> GYM PICKS';
      if (sub) sub.textContent = 'Four smart fitness finds selected for practical training, clever design and everyday use.';
      document.querySelectorAll('.ace-trending-card__badge').forEach((badge) => { badge.textContent = 'TRENDING'; });
    }
  };

  const applyAceFindzAuditFixes = (root = document) => {
    fixProductCardControls();
    updateHomeWorkoutCta(root);
    updateTopPicksHeading(root);
    updateHomepageProductCtas(root);
    enhanceSocialLinks(root);
    enhanceAccessibility(root);
    polishCollectionAndTrending();
  };

  document.addEventListener('DOMContentLoaded', () => applyAceFindzAuditFixes());
  document.addEventListener('shopify:section:load', (event) => applyAceFindzAuditFixes(event.target));
})();
